import styled from 'styled-components';
import { colors } from 'shared/defaultTheme';

export const TextAreaCustom = styled.textarea`
  resize: none;
  border-radius: 4px;
  border: 1px solid ${colors.lightSilverTwo};
  min-height: 140px !important;
  padding: 12px 6px !important;
  &:active,
  &:focus {
    border-color: ${colors.black} !important;
  }
`;
